import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dibuall"
};
const _hoisted_2 = {
  class: "dibu"
};
const _hoisted_3 = {
  class: "dibu_one acea-row row-between-wrapper"
};
const _hoisted_4 = {
  class: "dibu_one_yi"
};
const _hoisted_5 = {
  class: "dibu_tel"
};
const _hoisted_6 = {
  class: "dibu_dizhi"
};
const _hoisted_7 = {
  class: "dibu_one_san"
};
const _hoisted_8 = {
  class: "dibu_one_si"
};
const _hoisted_9 = {
  class: "dibu_gzh"
};
const _hoisted_10 = {
  class: "dibu_gzh_pic"
};
const _hoisted_11 = {
  class: "dibu_three"
};
const _hoisted_12 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "dibu_rexian"
  }, "服务热线", -1)), _createElementVNode("div", _hoisted_5, _toDisplayString($data.peizhiinfo.kefutel), 1), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "dibu_zongbu"
  }, "地址", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString($data.peizhiinfo.dizhi), 1)]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "dibu_one_er"
  }, [_createElementVNode("div", {
    class: "dibu_title"
  }, "科研服务"), _createElementVNode("div", {
    class: "dibu_item"
  }, "材料测试"), _createElementVNode("div", {
    class: "dibu_item"
  }, "模拟计算")], -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "dibu_title",
    onClick: _cache[0] || (_cache[0] = $event => $options.goxwlist(6, 4))
  }, "关于我们"), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[1] || (_cache[1] = $event => $options.goxwlist(1, 4))
  }, "行业新闻"), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[2] || (_cache[2] = $event => $options.goxwlist(2, 4))
  }, "文库资料"), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[3] || (_cache[3] = $event => $options.goxwlist(3, 4))
  }, "企业资讯"), _createElementVNode("div", {
    class: "dibu_item",
    onClick: _cache[4] || (_cache[4] = $event => $options.goxwlist(4, 4))
  }, "常见问题")]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/gongzhonghao.jpg"
  })]), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "dibu_gzh_txt"
  }, "众诚表征公众号", -1))])])]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "dibu_two"
  }, "友情链接", -1)), _createElementVNode("div", _hoisted_11, [_createTextVNode("版权所有©2025-2026 " + _toDisplayString($data.peizhiinfo.site_name) + " ", 1), _createElementVNode("a", _hoisted_12, _toDisplayString($data.peizhiinfo.beianhao), 1)])])]), _createElementVNode("div", {
    class: "backhome",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.scrollToTop && $options.scrollToTop(...args))
  }, [_createVNode(_component_el_image, {
    src: "https://zcbiaozheng.oss-cn-chengdu.aliyuncs.com/zcbzcss/backhome.png"
  })])], 64);
}